import { render, staticRenderFns } from "./QrPage.vue?vue&type=template&id=6024fbb3"
import script from "./QrPage.vue?vue&type=script&lang=js"
export * from "./QrPage.vue?vue&type=script&lang=js"
import style0 from "./QrPage.vue?vue&type=style&index=0&id=6024fbb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports